import { DialogProps, ROLE_ACTIONS } from "components/Actions/types";

import ManageRole from "../ManageRole";

const CreateRole = ({ isOpen, close }: DialogProps) => {
    return (
        <ManageRole
            action={ROLE_ACTIONS.CreateRole}
            isOpen={isOpen}
            close={close}
        />
    );
};

export default CreateRole;
